<tcc-simplePanel-signatures size="full">
  <div panel-body class="d-flex flex-column align-items-center">
    @if ((state$ | async) === 'ready') {
      <div class="d-flex flex-row flex-wrap" style="max-width: 782px;">
        <div class="row">
          <div class="col">
            <div>
              <app-signature-form [signatureInfo]="(initialSignature$ | async) || undefined"
              (signatureInfoChange)="signatureInfo = $event"></app-signature-form>
            </div>
          </div>
          <div class="col pb-3">
            <app-signature-renderer [signatureInfo]="signatureInfo"></app-signature-renderer>
          </div>
        </div>
        <div class="card text-dark">
          <div class="card-body">
            <p>
              After copying the signature to your clipboard (by clicking the Copy to Clipboard button), go to Outlook
              to update your signature.
            </p>
            <p>
              To update your signature go to <b>File</b> -> <b>options</b> (typically near bottom left).
              From the Outlook Options dialog go to the <b>Mail</b> settings pane and click <b>signatures...</b>.
              Create a new Signature, and paste the contents of the clipboard into the signature body.
              Then set the default signature for new signatures to the signature you just created.
              Finally, delete any old signatures.
            </p>
          </div>
        </div>
      </div>
    }
    @if ((state$ | async) !== 'ready') {
      <tcc-loadingOverlay-signatures style="overflow:hidden"></tcc-loadingOverlay-signatures>
    }
  </div>
</tcc-simplePanel-signatures>
